
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","width":"1em","height":"1em","viewBox":"0 0 18 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.052.004a.73.73 0 00-.434 1.247l.22.22H3.406a.73.73 0 00-.651 1.13.73.73 0 00.651.331h9.426l-.213.213a.73.73 0 101.034 1.027l1.46-1.46a.73.73 0 000-1.027l-1.46-1.46a.73.73 0 00-.6-.221zM.654 4.879A.73.73 0 000 5.61v8.763c0 .403.327.73.73.73h16.54a.73.73 0 00.73-.73V5.61a.73.73 0 00-.73-.73H.73a.73.73 0 00-.076 0zm.805 1.46h3.976a5.094 5.094 0 00-1.543 3.652c0 1.428.592 2.721 1.543 3.651H1.459V6.34zM9 6.34a3.639 3.639 0 013.649 3.652A3.639 3.639 0 019 13.642a3.639 3.639 0 01-3.649-3.651A3.639 3.639 0 019 6.34zm3.565 0h3.976v7.303h-3.976a5.094 5.094 0 001.543-3.651 5.094 5.094 0 00-1.543-3.651zm-3.573.23a.73.73 0 00-.722.745v.076c-.708.222-1.216.907-1.216 1.627 0 .975.924 1.704 1.946 1.704.446 0 .486.14.486.244 0 .201.004.243-.243.243h-1.46a.73.73 0 100 1.46h.487a.73.73 0 101.46 0V12.6c.708-.222 1.216-.915 1.216-1.635 0-.975-.924-1.704-1.946-1.704-.446 0-.486-.14-.486-.244 0-.201-.004-.243.243-.243h1.46a.73.73 0 100-1.46H9.73a.73.73 0 00-.738-.746zm-4.21 9.013a.73.73 0 00-.434.22l-1.46 1.46a.73.73 0 000 1.028l1.46 1.46a.73.73 0 101.034-1.027l-.213-.213h9.426a.73.73 0 100-1.46H5.16l.22-.22a.73.73 0 00-.6-1.248z"}})])
          )
        }
      }
    